export enum HomepageInfoCardType {
  CLINICAL_TECHNOLOGY = 'CLINICAL_TECHNOLOGY',
  TESTIMONIAL = 'TESTIMONIAL',
  KNOW_ABOUT_DOCTORS = 'KNOW_ABOUT_DOCTORS',
}

export interface HomepageInfoCard {
  imageUrl: string;
  bannerText: string;
  bannerSubText: string;
  navigationLink: string;
  colSpan: 1 | 2;
  type: HomepageInfoCardType;
  rebrandedBannerText?: string;
  customStyling?: string;
}

export const RetentionRevampCardStyling = 'tw-aspect-3/4';

export const RetentionRevampCardOverrides: Partial<Record<HomepageInfoCardType, Partial<HomepageInfoCard>>> = {
  [HomepageInfoCardType.CLINICAL_TECHNOLOGY]: {
    imageUrl: '/assets/images/clinically_proven.png',
  },
};

export const HomepageInfoCardsData: Record<string, HomepageInfoCard[]> = {
  en: [
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/clinical_tech.png',
      bannerText: 'Our Clinically <br> Proven <br> Technologies',
      rebrandedBannerText: 'Our clinically <br> proven <br> technologies',
      bannerSubText: 'Rooted in scientific research',
      navigationLink: '/clinical-technology',
      colSpan: 2,
      type: HomepageInfoCardType.CLINICAL_TECHNOLOGY
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/user_testimonials.png',
      bannerText: 'See what <br> our users <br> Say about us',
      bannerSubText: '',
      navigationLink: '/user/testimonialsNew',
      colSpan: 1,
      type: HomepageInfoCardType.TESTIMONIAL
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/about_doctors.png',
      bannerText: 'Know about <br> cureskin <br> doctors',
      rebrandedBannerText: 'Know about <br> Cure doctors',
      bannerSubText: '',
      navigationLink: '/doctors',
      colSpan: 1,
      type: HomepageInfoCardType.KNOW_ABOUT_DOCTORS
    }
  ],
  hi: [
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/clinical_tech.png',
      bannerText: 'हमारी क्लिनिकली <br> प्रूवेन टेक्नोलॉजीज़',
      bannerSubText: 'वैज्ञानिक रिसर्च पर आधारित, असरदार समाधान',
      navigationLink: '/clinical-technology',
      colSpan: 2,
      type: HomepageInfoCardType.CLINICAL_TECHNOLOGY
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/user_testimonials.png',
      bannerText: 'हमारे उपयोगकर्ता <br> हमारे बारे में <br> क्या कहते हैं।',
      bannerSubText: '',
      navigationLink: '/user/testimonialsNew',
      colSpan: 1,
      type: HomepageInfoCardType.TESTIMONIAL
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/about_doctors.png',
      bannerText: 'Cure के <br> डॉक्टरों के <br> बारे में जानें',
      bannerSubText: '',
      navigationLink: '/doctors',
      colSpan: 1,
      type: HomepageInfoCardType.KNOW_ABOUT_DOCTORS
    }
  ]
};

export const TreatmentPhilosophyData = {
  en: [
    {
      id: 0,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/cause_bassed.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/anatomy.svg',
      title: `Root Cause <br> Based`,
      subTitle: 'Healing your Skin and Scalp from Outside-In and Inside-Out.',
      content: `Cureskin's approach addresses both external symptoms and internal triggers of skin and hair concerns. By treating the visible symptoms while also factoring in hormonal imbalances, nutrition, and stressors, Cureskin ensures deep and lasting healing.`
    },
    {
      id: 1,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/specialist_care.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/care_calender.svg',
      title: `Continuous <br> Specialist care`,
      subTitle: `Doctor's guidance and supervision throughout your journey.`,
      content: `At Cureskin, every treatment plan is backed by experienced dermatologists who stay connected throughout your journey. From initial diagnosis to visible transformation, expect ongoing support, timely adjustments, and medical-grade supervision that inspires confidence.`
    },
    {
      id: 2,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/efficancy.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/people_efficacy.svg',
      title: `Efficacy Through <br> Personalisation`,
      subTitle: `All treatments designed based on individual needs.`,
      content: `Every regimen at Cureskin is tailored based on severity, sensitivity and individual concern. Using clinically studied, doctor-recommended actives, and AI-assisted photo-based diagnosis, the product combination and protocol is built only for you.`
    },
    {
      id: 3,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/programme.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/health_programme.svg',
      title: `Holistic Programme <br> Not Just Products`,
      subTitle: `Nutritional plan & lifestyle management guidance By experts`,
      content: `Cureskin is a holistic programme that includes not just topical and oral formulations but also dietary suggestions, lifestyle tweaks, stress management and habit coaching. Long-term results happen with the whole body support. Great skin is not just topical, its total.`
    }
  ],
  hi: [
    {
      id: 0,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/cause_bassed.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/anatomy.svg',
      title: `समस्या की जड़ <br> पर आधारित`,
      subTitle: 'स्किन और स्कैल्प को अंदर और बाहर से ठीक करना ताकि जड़ से समाधान मिले।',
      content: `Cureskin का तरीका स्किन और बालों की समस्याओं के बाहरी लक्षणों के साथ-साथ अंदरूनी कारणों को भी दूर करता है। हम सिर्फ दिखने वाली परेशानी नहीं, बल्कि उसके पीछे के कारण — हार्मोनल असंतुलन, पोषण की कमी और तनाव को भी समझकर इलाज करते हैं।इसी वजह से Cureskin से मिलने वाला असर गहरा और लंबे समय तक टिकने वाला होता है।`
    },
    {
      id: 1,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/specialist_care.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/care_calender.svg',
      title: `लगातार एक्सपर्ट <br> की देखरेख`,
      subTitle: `पूरी जर्नी में डॉक्टर की गाइडेंस और निगरानी से इलाज और भी भरोसेमंद बनता है।`,
      content: `Cureskin में हर ट्रीटमेंट प्लान एक्सपर्ट डर्मेटोलॉजिस्ट की देखरेख में तैयार किया जाता है। शुरुआती डायग्नोसिस से लेकर स्किन में साफ़ बदलाव दिखने तक, डॉक्टर लगातार जुड़े रहते हैं।आपको मिलता है समय-समय पर सपोर्ट, ज़रूरत पड़ने पर बदलाव और मेडिकल ग्रेड सुपरविज़न — जिससे भरोसा बना रहता है।`
    },
    {
      id: 2,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/efficancy.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/people_efficacy.svg',
      title: `आपके लिए बना, <br> असरदार इलाज`,
      subTitle: `हर ट्रीटमेंट आपकी स्किन की ज़रूरतों के हिसाब से तैयार किया जाता है।`,
      content: `Cureskin का हर ट्रीटमेंट प्लान आपकी स्किन की गंभीरता, सेंसिटिविटी और आपकी अपनी स्किन की ज़रूरतें के आधार पर बनाया जाता है। डॉक्टर द्वारा सुझाए गए एक्टिव्स और AI से की गई फोटो-डायग्नोसिस की मदद से, हर यूज़र के लिए प्रोडक्ट्स और रूटीन को खास तौर पर चुना जाता है।`
    },
    {
      id: 3,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/programme.png',
      icon: 'https://cdn.cureskin.com/app/img/treatment-philosophy/health_programme.svg',
      title: `सिर्फ प्रोडक्ट नहीं, <br> एक संपूर्ण देखभाल प्रोग्राम`,
      subTitle: `एक्सपर्ट्स द्वारा न्यूट्रिशन प्लान और लाइफस्टाइल गाइडेंस भी मिलती है।`,
      content: `Cureskin एक संपूर्ण देखभाल प्रोग्राम है — सिर्फ क्रीम और गोलियां नहीं, बल्कि डाइट, लाइफस्टाइल, स्ट्रेस मैनेजमेंट और हैबिट कोचिंग भी शामिल है। जब पूरे शरीर को बैलेंस मिलता है, तभी लंबे समय तक असर बना रहता है। खूबसूरत स्किन सिर्फ बाहर से नहीं, अंदर से भी बनती है।`
    }
  ]
};

export const ClinicalTechnologyHighlights = {
  en: [
    {
      id: 0,
      title: `Sustained <br> Release Actives`,
      subTitle: `Advanced delivery technology that ensures continuous absorption of actives for longer-lasting efficacy without irritation.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/release_actives.png',
    },
    {
      id: 1,
      title: `Bio-peptides`,
      subTitle: `Bio-mimetic ingredients that replicate naturally occurring peptides in the body and interact with targeted receptors in the skin.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/bio_peptides.png',
    },
    {
      id: 2,
      title: `Anti-Inflammatory <br> Defense`,
      subTitle: `Add-ons to calm, neutralize oxidative stress and reduce inflammation and work with treatment specific actives.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/anti_oxidant.png',
    },
    {
      id: 3,
      title: `Potent Cosmeceutical <br> Actives`,
      subTitle: `Compounds that go beyond cosmetics—combining pharmaceutical precision with visible benefits for both skin and hair.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/cosmeceutical_actives.png',
    },
    {
      id: 4,
      title: `Prescription Strength`,
      subTitle: `Scientifically validated molecules prescribed in clinically relevant strengths, based on diagnosis and dermatologist review.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/priscription_strength.png',
    },
  ],
  hi: [
    {
      id: 0,
      title: `धीरे-धीरे असर <br> करने वाले सक्रिय तत्व`,
      subTitle: `ऐडवांस डिलिवरी टेक्नोलॉजी जो सक्रिय तत्वों को धीरे-धीरे स्किन में सोखने देती है। इससे बिना किसी जलन के लंबे समय तक असर बना रहता है।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/release_actives.png',
    },
    {
      id: 1,
      title: `बायो-पेप्टाइड्स`,
      subTitle: `ऐसे तत्व जो शरीर में प्राकृतिक रूप से पाए जाने वाले पेप्टाइड्स की नकल करते हैं और स्किन के ज़रूरी रिसेप्टर्स के साथ मिलकर असर दिखाते हैं।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/bio_peptides.png',
    },
    {
      id: 2,
      title: `सूजन को कम <br> करने वाली सुरक्षा`,
      subTitle: `ऐसे अतिरिक्त तत्व जो स्किन को शांत करें, ऑक्सीडेटिव तनाव को कम करें और ट्रीटमेंट के मुख्य एक्टिव्स के साथ मिलकर बेहतर परिणाम दें।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/anti_oxidant.png',
    },
    {
      id: 3,
      title: `शक्तिशाली <br> कॉस्मेस्युटिकल तत्व`,
      subTitle: `ऐसे तत्व जो सिर्फ कॉस्मेटिक नहीं, बल्कि दवा जैसी सटीकता और गहराई से काम करते हैं — जिससे स्किन और बालों दोनों में साफ़ बदलाव नजर आता है।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/cosmeceutical_actives.png',
    },
    {
      id: 4,
      title: `चिकित्सकीय ताकत वाले तत्व`,
      subTitle: `साइंटिफिक रूप से प्रमाणित और डर्मेटोलॉजिस्ट की सलाह से चुने गए तत्व — जो आपकी समस्या की गंभीरता के हिसाब से असरदार मात्रा में दिए जाते हैं।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/priscription_strength.png',
    },
  ]
};
